import {gsap} from "gsap";

import {CustomEase} from "gsap/CustomEase";
import {ExpoScaleEase, RoughEase, SlowMo} from "gsap/EasePack";

import {Flip} from "gsap/Flip";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Observer} from "gsap/Observer";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import {Draggable} from "gsap/Draggable";
import {MotionPathPlugin} from "gsap/MotionPathPlugin";
import {EaselPlugin} from "gsap/EaselPlugin";
import {PixiPlugin} from "gsap/PixiPlugin";
import {TextPlugin} from "gsap/TextPlugin";

// OR JUST USE https://nuxt.com/modules/v-gsap


export default defineNuxtPlugin((nuxtApp) => {
    gsap.registerPlugin(Flip,
        ScrollTrigger,
        Observer,
        ScrollToPlugin,
        Draggable,
        MotionPathPlugin,
        EaselPlugin,
        PixiPlugin,
        TextPlugin,
        RoughEase,
        ExpoScaleEase,
        SlowMo,
        CustomEase
    )
    return {
        provide: {
            gsap,
            ScrollTrigger,
            Observer,
            ScrollToPlugin,
            Draggable,
            MotionPathPlugin,
            EaselPlugin,
            PixiPlugin,
            TextPlugin,
            RoughEase,
            ExpoScaleEase,
            SlowMo,
            CustomEase
        }
    }
})